import vegBasket from '../../assets/images/about/vegbasket.png';
import bgImage from '../../assets/images/about/background.png';

const BasketSection = () => {
    return (
        <div
            className="bg-cover bg-center py-16 relative  px-6 md:px-20 font-lato"
            style={{ backgroundImage: `url(${bgImage})` }}
        >
            <div className="absolute inset-0 bg-green-600/80"></div>
            <div className="container mx-auto px-10 relative z-10">
                <div className="flex flex-col md:flex-row items-start">
                    <div className="w-full md:w-1/2 flex justify-center mb-10 md:mb-0">
                        <img
                            src={vegBasket}
                            alt="Fresh vegetables basket"
                            className="w-full max-w-md md:max-w-lg lg:max-w-xl h-auto rounded-xl"
                        />
                    </div>
                    <div className=" text-white pl-5">
                        <h2 className="text-3xl font-bold mb-8 text-white">We let the facts speak for themselves :</h2>
                        <ul className="space-y-6 text-lg">
                            <li className="flex items-center">
                                <span className="text-white text-xl mr-3">✓</span>
                                <span>Launched 39 stores across chennai - each ranging between 4000 & 8000 sq ft.</span>
                            </li>
                            <li className="flex items-center">
                                <span className="text-white text-xl mr-3">✓</span>
                                <span>Occupying 1.60 lakh sq ft of retail space</span>
                            </li>
                            <li className="flex items-center">
                                <span className="text-white text-xl mr-3">✓</span>
                                <span>And of course – countless satisfied customers!</span>
                            </li>
                        </ul>
                        <p className="mt-8 text-lg leading-relaxed">
                            Grace Super Market now intends to expand its operations to other Places soon to increase its retail footprint to more than 10,00,000 sq ft and a customer base of more than 6 crore Indians.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BasketSection;